import React from 'react';
import { Link } from 'react-router-dom';
import { AppointmentVirtualES } from '@bb/domain/dist/types';
import { Button, Icon } from 'components';

import DateSection from './DateSection';
import ListingSection from './ListingSection';
import TaskLayout from './TaskLayout';

type AppointmentRequestedItemProps = {
  appointment: AppointmentVirtualES;
};

const FeedbackRequestedItem: React.FC<AppointmentRequestedItemProps> = ({
  appointment,
}) => (
    <TaskLayout
      title="Feedback Requested"
      content={
        <>
          <ListingSection
            dataCy="feedback-listing-details"
            listing={appointment.listing}
          />
          <DateSection
            dataCy="feedback-requested-date"
            startDate={appointment.time}
            endDate={appointment.timeEnd}
          />
        </>
      }
      buttons={
        <Link
          to={`/my_business/appointment/${appointment.id}/feedback`}
          data-cy="feedback-requested-link"
        >
          <Button
            size="small"
            icon={
              <Icon
                type="antdMessageOutlined"
                width={14}
                offset={[0, -2]}
                color="gray8"
              />
            }
          >
            Provide Feedback
          </Button>
        </Link>
      }
      dataCy="feedback-requested-item"
    />
  );

export default FeedbackRequestedItem;
